let languagesLoadPromise: Promise<void> | null = null;

export const loadLanguagesOnce = async (): Promise<void> => {
  const { languagesModule }: any = await import("@/store");

  const isLanguagesLoaded = (): boolean => {
    return (
      Array.isArray(languagesModule.getLanguages) &&
      languagesModule.getLanguages.length > 0
    );
  };

  if (isLanguagesLoaded()) return Promise.resolve();

  if (!languagesLoadPromise) {
    const loadLanguagesPromise =
      typeof languagesModule.LoadLanguages === "function"
        ? languagesModule.LoadLanguages()
        : Promise.resolve();

    languagesLoadPromise = loadLanguagesPromise.catch((error: unknown) => {
      languagesLoadPromise = null;
      throw error;
    });
  }

  await languagesLoadPromise;
};
